<template>
  <div class="mt-3">
    <b-row>
      <b-col class="text-right" md="3" cols="12">ชื่อชุมชน :</b-col>
      <b-col class="text-left" md="8" cols="12">{{ model.name }}</b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col class="text-right" md="3" cols="12">ที่ตั้ง :</b-col>
      <b-col class="text-left" md="8" cols="12">{{ model.address }}</b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col class="text-right" md="3" cols="12">ความเป็นมา :</b-col>
      <b-col class="text-left" md="8" cols="12">
        <textarea
          v-model="model.description"
          class="px-4 input_text w-100"
          rows="5"
        >
        </textarea>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col class="text-right" md="3" cols="12"
        >ทรัพยากรชีวภาพที่มีในชุมชน :</b-col
      >
      <b-col class="text-left" md="8" cols="12">
        <textarea
          class="px-4 input_text w-100"
          v-model="model.resource"
          rows="5"
        ></textarea>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col class="text-right" md="3" cols="12">รูปภาพ :</b-col>
      <b-col md="8" cols="12">
        <div class="d-flex justify-content-start">
          <b-row>
            <b-col cols="2" v-for="(item, index) in image" :key="item.id">
              <div v-if="!item.link">
                <label
                  class="
                    border border-dark
                    mr-3
                    d-flex
                    align-items-center
                    justify-content-center
                    pointer
                  "
                  style="width: 100px; height: 100px"
                  :for="`upload${item}`"
                >
                  <b-icon class="font-title" icon="plus-circle"></b-icon>
                </label>
                <input
                  @change="uploadImage($event, index)"
                  :id="`upload${item}`"
                  style="visibility: hidden; width: 0px"
                  type="file"
                  accept="image/*"
                />
              </div>
              <div v-else>
                <img
                  class="mr-3 fluid"
                  style="width: 100px; height: 100px"
                  :src="item.link"
                  alt=""
                />
                <b-icon
                  fab
                  icon="dash-circle"
                  class="close"
                  @click="removeImage(index)"
                ></b-icon>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row class="justify-content-end mb-5">
      <b-col md="2">
        <b-button class="btn btn-block shadow none-background" pill
          >ยกเลิก</b-button
        ></b-col
      >
      <b-col md="3">
        <b-button
          @click="save"
          class="btn btn-block shadow green-background"
          pill
          >บันทึก</b-button
        ></b-col
      >
      <b-col md="1"></b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Swal from "sweetalert2";
import { domain } from "@/utils/Constants";
import axios from "axios";
export default {
  computed: {
    ...mapState({
      accessToken: (state) => state.AuthModule.accessToken,
      user: (state) => state.AuthModule.userData,
    }),
  },
  data() {
    return {
      image: [
        { id: 1, link: "" },
        { id: 2, link: "" },
        { id: 3, link: "" },
        { id: 4, link: "" },
        { id: 5, link: "" },
      ],
      model: {
        name: "",
        description: "",
        address: "",
        resource: "",
      },
      form: {
        progressTemplate: [{ date: null, description: null, file: null }],
      },
    };
  },
  props: {
    community: {
      default: {
        name: "",
        description: "",
        address: "",
        resource: "",
      },
    },
  },
  watch: {
    community: function (newVal, oldVal) {
      this.model = newVal;
      let imageList = newVal.image_url;
      if (imageList) {
        this.image.forEach((item, index) => {
          if (imageList[index]) {
            item.link = imageList[index];
          }
        });
      } else {
        this.image = [
          { id: 1, link: "" },
          { id: 2, link: "" },
          { id: 3, link: "" },
          { id: 4, link: "" },
          { id: 5, link: "" },
        ];
      }
    },
  },
  created() {
    this.model = this.community;
    let imageList = this.community.image_url;
    if (imageList) {
      this.image.forEach((item, index) => {
        if (imageList[index]) {
          item.link = imageList[index];
        }
      });
    }
  },
  methods: {
    removeImage(index) {
      this.image[index].link = "";
    },
    uploadImage(event, index) {
      if (event.target.files.length > 0) {
        let image = event.target.files[0];
        var formData = new FormData();
        formData.append("image", image);
        formData.append("token", this.accessToken);
        axios({
          method: "post",
          url: domain + "/api/uploadImage",
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        }).then((res) => {
          this.image[index].link = res.data.result.image_url;
        });
      }
    },
    save() {
      let imageList = [];
      this.image.map((x) => {
        if (x.link) imageList.push(x.link);
      });
      this.model.image_url = imageList;
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch("communityModule/onStoreCommunity", this.model)
            .then((res) => {
              if (res == 200) {
                Swal.hideLoading();
                this.$emit("onRefresh");
              } else {
                Swal.clickConfirm();
              }
            });
        },
      });
    },
  },
};
</script>

<style>
.close {
  position: absolute;
  color: #faf8f8;
  top: 36%;
  left: 53%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
</style>